import React, { Component } from "react";
import AboutUsCategories from '../api/about-us-categories';
import AboutUsPosts from '../api/about-us-posts';
import { getStaticText } from '../../../lables/lablesService';
import Spinner from '../../../components/spinner-component/Spinner';
import RecordsList from './RecordsList';
import RecordsForm from './RecordsForm';
import Popup from "reactjs-popup";

import 'reactjs-popup/dist/index.css';
import '../../../scss/os-global.scss';


class CategoriesPage extends Component {
    
    constructor(props) {
        super(props);

        this.page = 1;
        this.per_page = 10;
        this.all_pages = 0;
        this.order = {'type_id' : 'ASC', 'position' : 'ASC'};
        this.posts = [];
        this.post_types = {};

        this.post_info = {};
        this.empty_post_info = {
            'id' : 0,
            'image' : '',
            'image_name' : '',
            'title' : '',
            'content' : '',
            'type_id' : 0,
            'active' : 1,
            'position' : 99999
        };

        this.state = {
            'has_data' : false,
            'show_popup' : false
        };
    }


    openEditPostForm ( post_for_edit  ) {
        Object.assign(
            this.post_info,
            post_for_edit,
            {
                'image' : AboutUsPosts.getImageUrl(post_for_edit.image)
            }
        );
        this.popupToggle();
    }


    openAddNewPostForm () {
        Object.assign(
            this.post_info,
            this.empty_post_info
        );
        this.popupToggle();
    }


    popupToggle () {
        this.setState({
            'show_popup' : !this.state.show_popup
        });
    }


    async deletePost ( post_for_delete ) {
        if ( !window.confirm(getStaticText('remove_confirm_text')) )
            return false;

        let result = await AboutUsPosts.remove( post_for_delete.id );
        if ( !result ) {
            window.alert( getStaticText('remove_error') );
        } else {
            window.alert( getStaticText('remove_success') );
            this.page = 1;
            this.getRecordsList();
        }
    }


    async changePage (page_number = 1) {
        this.page = page_number;
        await this.getRecordsList();
    }


    async changeOrder (new_order = {}) {
        this.order = new_order;
        await this.getRecordsList();
    }


    async formCallback () {
        this.page = 1;
        this.popupToggle();
        await this.getRecordsList();
    }


    async getRecordsList () {
        this.setState({
            'has_data' : false
        });

        let list_response = await AboutUsPosts.list({
                                                    'page' : this.page,
                                                    'per_page' : this.per_page,
                                                    'order' : this.order
                                                });
        if ( typeof(list_response.rows) !== 'undefined' ) {
            this.posts = list_response.rows;
            this.all_pages = list_response.all_pages;
        }
        
        this.setState({
            'has_data' : true
        });
    }


    async componentDidMount () {
        let type_list_response = await AboutUsCategories.list({
                                                        'page' : 1,
                                                        'per_page' : 0,
                                                        'order' : {'id' : 'DESC'},
                                                        'where' : {'active' : 1}
                                                    });
        if ( typeof(type_list_response.rows) !== 'undefined' ) {
            for ( let row_key in type_list_response.rows ) {
                this.post_types[type_list_response.rows[row_key].id] = type_list_response.rows[row_key].name;
            }
        }

        await this.getRecordsList();
    }


    render () {
        let content = null;
        if ( !this.state.has_data ) {
            content = (<div className="col-lg-12 text-center">{<Spinner />}</div>);
        } else {
            content = (<>
                
                <div className="col-lg-12 text-end">
                    <button 
                        onClick={this.openAddNewPostForm.bind(this)}
                        className="btn btn-success text-white"
                    >
                        {getStaticText('aup_add_new_button_label')}
                    </button>
                </div>

                <Popup
                    open={this.state.show_popup}
                    closeOnDocumentClick={false}
                    closeOnEscape={false}
                    className="os-popup"
                >
                    <>
                        <div className="os-popup-header">
                            <span className="op-popup-title">
                                {this.post_info.id ? getStaticText('aup_edit_popup_title') : getStaticText('aup_add_new_popup_title')}
                            </span>
                            <button
                                onClick={this.popupToggle.bind(this)}
                                className="os-popup-close-button"
                            >
                                <i className="fa fa-times" />
                            </button>
                        </div>

                        <div className="os-popup-body">
                            <RecordsForm
                                post_info={this.post_info}
                                post_types={this.post_types}
                                formCallback={this.formCallback.bind(this)}
                            />
                        </div>
                    </>
                </Popup>

                <RecordsList 
                    posts={this.posts}
                    page={this.page}
                    all_pages={this.all_pages}
                    types={this.post_types}
                    order={this.order}
                    changeOrder={this.changeOrder.bind(this)}
                    changePage={this.changePage.bind(this)}
                    editFunction={this.openEditPostForm.bind(this)}
                    deleteFunction={this.deletePost.bind(this)}
                />
            </>);
        }

        return (<div className="row">
                    <div className="col-lg-12">
                        <h2>{getStaticText('aup_section_title')}</h2>
                    </div>
                    {content}
                </div>);
    }
}


export default CategoriesPage;